// Product Types Configuration - These ARE the products (pre-defined)
export const productCategories = [
  {
    id: 'finestre',
    name: 'Finestre',
    icon: 'singleSash',
    description: 'Finestre standard con apertura a battente o vasistas',
    subcategories: [
      { id: 'finestra_1_anta', name: 'Finestra 1 Anta', icon: 'singleSash', defaultPrice: 250 },
      { id: 'finestra_2_ante', name: 'Finestra 2 Ante', icon: 'doubleSash', defaultPrice: 280 },
      { id: 'finestra_3_ante', name: 'Finestra 3 Ante', icon: 'tripleSash', defaultPrice: 320 },
      { id: 'finestra_1_anta_sopraluce', name: 'Finestra 1 Anta + Sopraluce', icon: 'singleWithTopLight', defaultPrice: 300 },
      { id: 'finestra_1_anta_sottoluce', name: 'Finestra 1 Anta + Sottoluce', icon: 'singleWithBottomLight', defaultPrice: 300 },
      { id: 'finestra_2_ante_sopraluce', name: 'Finestra 2 Ante + Sopraluce', icon: 'doubleWithTopLight', defaultPrice: 350 },
      { id: 'finestra_fissa', name: 'Finestra Fissa', icon: 'fixedWindow', defaultPrice: 180 },
      { id: 'finestra_quadrante', name: 'Finestra Centinata 1 Anta', icon: 'quadrantWindow', defaultPrice: 400 },
      { id: 'finestra_centinata_2_ante', name: 'Finestra Centinata 2 Ante', icon: 'arch2Window', defaultPrice: 450 },
      { id: 'finestra_triangolo', name: 'Finestra Triangolare', icon: 'triangleWindow', defaultPrice: 450 },
      { id: 'finestra_trapezoidale', name: 'Finestra Trapezoidale', icon: 'trapezoidWindow', defaultPrice: 450 },
      { id: 'finestra_oblo', name: 'Finestra Oblò', icon: 'circleWindow', defaultPrice: 500 },
    ]
  },
  {
    id: 'portafinestre',
    name: 'Portafinestre',
    icon: 'frenchDoor',
    description: 'Porte-finestre con accesso esterno',
    hasThresholdOption: true,
    subcategories: [
      { id: 'portafinestra_1_anta', name: 'Portafinestra 1 Anta', icon: 'frenchDoor', defaultPrice: 320 },
      { id: 'portafinestra_2_ante', name: 'Portafinestra 2 Ante', icon: 'doubleFrenchDoor', defaultPrice: 380 },
      { id: 'portafinestra_3_ante', name: 'Portafinestra 3 Ante', icon: 'tripleFrenchDoor', defaultPrice: 480 },
      { id: 'portafinestra_4_ante', name: 'Portafinestra 4 Ante', icon: 'quadFrenchDoor', defaultPrice: 580 },
      { id: 'portafinestra_1_anta_sopraluce', name: 'Portafinestra 1 Anta + Sopraluce', icon: 'singleWithTopLight', defaultPrice: 400 },
      { id: 'portafinestra_2_ante_sopraluce', name: 'Portafinestra 2 Ante + Sopraluce', icon: 'doubleWithTopLight', defaultPrice: 450 },
      { id: 'portafinestra_3_ante_sopraluce', name: 'Portafinestra 3 Ante + Sopraluce', icon: 'tripleWithTopLight', defaultPrice: 560 },
      { id: 'portafinestra_4_ante_sopraluce', name: 'Portafinestra 4 Ante + Sopraluce', icon: 'quadWithTopLight', defaultPrice: 660 },
    ]
  },
  {
    id: 'porte',
    name: 'Porte d\'Ingresso',
    icon: 'entryDoor',
    description: 'Porte d\'ingresso e porte interne',
    subcategories: [
      // Configurations offered by the selection modal (windowSelectionFlows.js)
      { id: 'porta_ingresso_1_anta', name: "Porta d'Ingresso", icon: 'entryDoorSingle', defaultPrice: 750 },
      { id: 'porta_ingresso_fisso_sx', name: "Porta d'Ingresso + Fisso SX", icon: 'entryDoorFissoSx', defaultPrice: 850 },
      { id: 'porta_ingresso_fisso_dx', name: "Porta d'Ingresso + Fisso DX", icon: 'entryDoorFissoDx', defaultPrice: 850 },
      { id: 'porta_ingresso_semifisso_sx', name: "Porta d'Ingresso + Semifisso SX", icon: 'entryDoorSemifissoSx', defaultPrice: 900 },
      { id: 'porta_ingresso_semifisso_dx', name: "Porta d'Ingresso + Semifisso DX", icon: 'entryDoorSemifissoDx', defaultPrice: 900 },
      // Earlier generic types, kept so existing quotes and price lists keep working
      { id: 'porta_ingresso_vetro', name: 'Porta Ingresso con Vetro', icon: 'entryDoor', defaultPrice: 800 },
      { id: 'porta_ingresso_cieca', name: 'Porta Ingresso Cieca', icon: 'entryDoor', defaultPrice: 700 },
      { id: 'porta_ingresso_laterale', name: 'Porta con Laterale Fisso', icon: 'entryDoor', defaultPrice: 1000 },
    ]
  },
  {
    id: 'scorrevoli_patio',
    name: 'Scorri-Ribalta PATIO',
    icon: 'scorriRibaltaPatio',
    description: 'Sistema scorrevole con funzione ribalta',
    hasThresholdOption: true,
    subcategories: [
      { id: 'patio_2_ante', name: 'PATIO 2 Ante', icon: 'slidingDoor', defaultPrice: 450 },
      { id: 'patio_3_ante', name: 'PATIO 3 Ante', icon: 'slidingDoor', defaultPrice: 550 },
      { id: 'patio_4_ante', name: 'PATIO 4 Ante', icon: 'slidingDoor', defaultPrice: 650 },
    ]
  },
  {
    id: 'scorrevoli',
    name: 'Sistemi Scorrevoli',
    icon: 'slidingDoor',
    description: 'Scorrevoli classici e minimali',
    hasThresholdOption: true,
    subcategories: [
      { id: 'scorrevole_2_ante', name: 'Scorrevole 2 Ante', icon: 'slidingDoor', defaultPrice: 400 },
      { id: 'scorrevole_3_ante', name: 'Scorrevole 3 Ante', icon: 'slidingDoor', defaultPrice: 500 },
      { id: 'scorrevole_4_ante', name: 'Scorrevole 4 Ante', icon: 'slidingDoor', defaultPrice: 600 },
      { id: 'scorrevole_minimale', name: 'Scorrevole Minimale', icon: 'minimalSliding', defaultPrice: 700 },
      { id: 'scorrevole_angolo', name: 'Scorrevole ad Angolo', icon: 'minimalSliding', defaultPrice: 900 },
      { id: 'scorrevole_traslante', name: 'Scorrevole Traslante', icon: 'slidingDoor', defaultPrice: 550 },
    ]
  },
  {
    id: 'pieghevoli',
    name: 'Sistemi Pieghevoli',
    icon: 'foldingSystem',
    description: 'Folding systems / sistemi a libro',
    hasThresholdOption: true,
    subcategories: [
      { id: 'pieghevole_2_ante', name: 'Pieghevole 2 Ante', icon: 'folding2', defaultPrice: 500 },
      { id: 'pieghevole_3_ante', name: 'Pieghevole 3 Ante', icon: 'folding3', defaultPrice: 600 },
      { id: 'pieghevole_4_ante', name: 'Pieghevole 4 Ante', icon: 'folding4', defaultPrice: 700 },
      { id: 'pieghevole_6_ante', name: 'Pieghevole 6 Ante', icon: 'folding6', defaultPrice: 900 },
    ]
  },
  {
    id: 'portoni',
    name: 'Portoni',
    icon: 'garageDoor',
    description: 'Portoni garage e sezionali',
    subcategories: [
      { id: 'portone_sezionale', name: 'Portone Sezionale', icon: 'garageDoor', defaultPrice: 350 },
      { id: 'portone_basculante', name: 'Portone Basculante', icon: 'garageDoor', defaultPrice: 300 },
      { id: 'portone_scorrevole', name: 'Portone Scorrevole', icon: 'garageDoor', defaultPrice: 400 },
    ]
  },
  {
    id: 'tapparelle',
    name: 'Tapparelle',
    icon: 'rollerShutter',
    description: 'Tapparelle e avvolgibili',
    subcategories: [
      { id: 'tapparella_pvc', name: 'Tapparella PVC', icon: 'rollerShutter', defaultPrice: 80 },
      { id: 'tapparella_alluminio', name: 'Tapparella Alluminio', icon: 'rollerShutter', defaultPrice: 120 },
      { id: 'tapparella_coibentata', name: 'Tapparella Coibentata', icon: 'rollerShutter', defaultPrice: 150 },
      { id: 'tapparella_blindata', name: 'Tapparella Blindata', icon: 'rollerShutter', defaultPrice: 250 },
    ]
  },
  {
    id: 'persiane',
    name: 'Persiane',
    icon: 'shutter',
    description: 'Persiane e scuri',
    subcategories: [
      { id: 'persiana_1_anta', name: 'Persiana 1 Anta', icon: 'shutter1Anta', defaultPrice: 200 },
      { id: 'persiana_2_ante', name: 'Persiana 2 Ante', icon: 'shutter', defaultPrice: 250 },
      { id: 'persiana_3_ante', name: 'Persiana 3 Ante', icon: 'shutter3Ante', defaultPrice: 320 },
      { id: 'persiana_4_ante', name: 'Persiana 4 Ante', icon: 'shutter4Ante', defaultPrice: 400 },
      { id: 'persiana_scorrevole_sx', name: 'Persiana Scorrevole SX', icon: 'shutterScorrevoleSx', defaultPrice: 350 },
      { id: 'persiana_scorrevole_dx', name: 'Persiana Scorrevole DX', icon: 'shutterScorrevoleDx', defaultPrice: 350 },
      { id: 'scuro_1_anta', name: 'Scuro 1 Anta', icon: 'scuro1Anta', defaultPrice: 180 },
      { id: 'scuro_2_ante', name: 'Scuro 2 Ante', icon: 'scuro2Ante', defaultPrice: 220 },
    ]
  },
  {
    id: 'cassonetti',
    name: 'Cassonetti',
    icon: 'cassonetto',
    description: 'Cassonetti per tapparelle e avvolgibili',
    subcategories: [
      { id: 'cassonetto_alluminio', name: 'Cassonetto Alluminio', icon: 'cassonetto', defaultPrice: 90 },
      { id: 'cassonetto_pvc', name: 'Cassonetto PVC', icon: 'cassonetto', defaultPrice: 70 },
      { id: 'cassonetto_lamiera', name: 'Cassonetto Lamiera', icon: 'cassonetto', defaultPrice: 55 },
    ]
  },
  {
    id: 'monoblocchi',
    name: 'Monoblocco',
    icon: 'monoblocco',
    description: 'Monoblocchi per serramenti',
    subcategories: [
      { id: 'monoblocco_pvc', name: 'Monoblocco PVC', icon: 'monoblocco', defaultPrice: 120 },
      { id: 'monoblocco_eps', name: 'Monoblocco EPS', icon: 'monoblocco', defaultPrice: 100 },
      { id: 'monoblocco_alluminio', name: 'Monoblocco Alluminio', icon: 'monoblocco', defaultPrice: 140 },
    ]
  },
  {
    id: 'controtelai',
    name: 'Controtelaio',
    icon: 'controtelaio',
    description: 'Controtelai per serramenti',
    subcategories: [
      { id: 'controtelaio_legno', name: 'Controtelaio Legno', icon: 'controtelaio', defaultPrice: 40 },
      { id: 'controtelaio_alluminio', name: 'Controtelaio Alluminio', icon: 'controtelaio', defaultPrice: 55 },
      { id: 'controtelaio_pvc', name: 'Controtelaio PVC', icon: 'controtelaio', defaultPrice: 45 },
    ]
  },
  {
    id: 'zanzariere',
    name: 'Zanzariere',
    icon: 'mosquitoNet',
    description: 'Zanzariere di vario tipo',
    subcategories: [
      { id: 'zanzariera_verticale', name: 'Zanzariera Verticale', icon: 'mosquitoNet', defaultPrice: 60 },
      { id: 'zanzariera_laterale', name: 'Zanzariera Laterale', icon: 'mosquitoNet', defaultPrice: 70 },
      { id: 'zanzariera_plisse', name: 'Zanzariera Plissé', icon: 'mosquitoNet', defaultPrice: 100 },
      { id: 'zanzariera_fissa', name: 'Zanzariera Fissa', icon: 'mosquitoNet', defaultPrice: 40 },
      { id: 'zanzariera_battente', name: 'Zanzariera Battente', icon: 'mosquitoNet', defaultPrice: 90 },
    ]
  },
  {
    id: 'frangisole',
    name: 'Frangisole',
    icon: 'externalBlind',
    description: 'Frangisole e brise-soleil',
    subcategories: [
      { id: 'frangisole_fisso', name: 'Frangisole Fisso', icon: 'externalBlind', defaultPrice: 180 },
      { id: 'frangisole_orientabile', name: 'Frangisole Orientabile', icon: 'externalBlind', defaultPrice: 280 },
      { id: 'frangisole_scorrevole', name: 'Frangisole Scorrevole', icon: 'externalBlind', defaultPrice: 350 },
    ]
  },
  {
    id: 'tende',
    name: 'Tende da Sole / Screen',
    icon: 'screen',
    description: 'Tende tecniche e screen',
    subcategories: [
      { id: 'tenda_cassonetto', name: 'Tenda con Cassonetto', icon: 'screen', defaultPrice: 150 },
      { id: 'tenda_bracci', name: 'Tenda a Bracci', icon: 'screen', defaultPrice: 200 },
      { id: 'screen_esterno', name: 'Screen Esterno', icon: 'screen', defaultPrice: 180 },
      { id: 'pergola_bioclimatica', name: 'Pergola Bioclimatica', icon: 'screen', defaultPrice: 500 },
    ]
  }
];

// Materials/Profiles available
export const profileTypes = [
  { id: 'pvc', name: 'PVC', shortName: 'PVC', defaultMultiplier: 1.0 },
  { id: 'alluminio_freddo', name: 'Alluminio Freddo', shortName: 'All. Freddo', defaultMultiplier: 1.1 },
  { id: 'alluminio_termico', name: 'Alluminio Termico', shortName: 'All. Termico', defaultMultiplier: 1.3 },
  { id: 'legno', name: 'Legno', shortName: 'Legno', defaultMultiplier: 1.4 },
  { id: 'legno_alluminio', name: 'Legno / Alluminio', shortName: 'Legno/All.', defaultMultiplier: 1.6 },
  { id: 'alluminio_legno', name: 'Alluminio / Legno', shortName: 'All./Legno', defaultMultiplier: 1.5 },
  { id: 'ibrido', name: 'Ibrido', shortName: 'Ibrido', defaultMultiplier: 1.2 },
];

// Legacy materials for backwards compatibility
export const materials = profileTypes;

// Glass types
export const glassTypes = [
  { id: 'none', name: '-', priceAdd: 0 },
  { id: 'doppio', name: 'Doppio Vetro 4-16-4', priceAdd: 0 },
  { id: 'triplo', name: 'Triplo Vetro 4-12-4-12-4', priceAdd: 50 },
  { id: 'basso_emissivo', name: 'Basso Emissivo', priceAdd: 30 },
  { id: 'selettivo', name: 'Vetro Selettivo', priceAdd: 40 },
  { id: 'stratificato', name: 'Stratificato 33.1', priceAdd: 35 },
  { id: 'stratificato_44', name: 'Stratificato 44.2', priceAdd: 60 },
  { id: 'stratificato_33_selettivo_argon', name: 'Stratificato 33.1/16/33.1 Selettivo + Gas Argon', priceAdd: 0 },
  { id: 'acustico', name: 'Acustico', priceAdd: 70 },
  { id: 'satinato', name: 'Satinato/Opaco', priceAdd: 25 },
  { id: 'specchiato', name: 'Specchiato', priceAdd: 45 },
];

// Opening types
export const openingTypes = [
  { id: 'anta_ribalta', name: 'Anta-Ribalta', priceAdd: 0 },
  { id: 'battente', name: 'Battente', priceAdd: 0 },
  { id: 'battente_esterno', name: 'Battente Esterno', priceAdd: 20 },
  { id: 'vasistas', name: 'Vasistas', priceAdd: 0 },
  { id: 'bilico', name: 'Bilico', priceAdd: 80 },
  { id: 'fisso', name: 'Fisso', priceAdd: -30 },
  { id: 'saliscendi', name: 'Saliscendi', priceAdd: 50 },
  { id: 'scorrevole', name: 'Scorrevole', priceAdd: 0 },
  { id: 'scorri_ribalta', name: 'Scorri-Ribalta', priceAdd: 0 },
];

// Entry door panel (chosen in the selection modal after the opening)
export const doorPanels = [
  { id: 'cieco', name: 'Pannello cieco', icon: 'doorPanelCieco', priceAdd: 0 },
  { id: 'vetro', name: 'Pannello con vetro', icon: 'doorPanelVetro', priceAdd: 150 },
];

// Glazing bead types (Fermavetro)
export const glazingBeadTypes = [
  { id: 'tondo', name: 'Fermavetro Tondo', priceAdd: 0 },
  { id: 'quadro', name: 'Fermavetro Quadro', priceAdd: 0 },
  { id: 'raggiato', name: 'Fermavetro Raggiato', priceAdd: 10 },
];

// Threshold options (for French doors)
export const thresholdOptions = [
  { id: 'standard', name: 'Soglia Standard', priceAdd: 0 },
  { id: 'ribassata', name: 'Soglia Ribassata', priceAdd: 40 },
  { id: 'calpestabile', name: 'Soglia Calpestabile', priceAdd: 80 },
  { id: 'a_filo', name: 'Soglia a Filo Pavimento', priceAdd: 120 },
];

// Colors
export const defaultColors = [
  { id: 'none', name: '-', hex: 'transparent', priceAdd: 0 },
  { id: 'bianco_9010', name: 'Bianco', hex: '#f5f5f5', priceAdd: 0 },
  { id: 'bianco_9016', name: 'Bianco Opaco', hex: '#ffffff', priceAdd: 0 },
  { id: 'avorio_1013', name: 'Avorio', hex: '#e8e4d8', priceAdd: 0 },
  { id: 'grigio_7016', name: 'Grigio Antracite', hex: '#383e42', priceAdd: 30 },
  { id: 'grigio_7035', name: 'Grigio Chiaro', hex: '#c4c9c7', priceAdd: 20 },
  { id: 'marrone_8017', name: 'Marrone', hex: '#3e2b23', priceAdd: 30 },
  { id: 'nero_9005', name: 'Nero', hex: '#0e0e10', priceAdd: 40 },
  { id: 'verde_6005', name: 'Verde', hex: '#0f4336', priceAdd: 35 },
  { id: 'rosso_3003', name: 'Rosso', hex: '#8d1d2c', priceAdd: 35 },
  { id: 'effetto_legno_rovere', name: 'Effetto Legno Rovere', hex: '#a67b52', priceAdd: 60 },
  { id: 'effetto_legno_noce', name: 'Effetto Legno Noce', hex: '#5c4033', priceAdd: 60 },
  { id: 'effetto_legno_douglas', name: 'Effetto Legno Douglas', hex: '#c4956a', priceAdd: 60 },
  { id: 'bicolore', name: 'Bicolore (interno/esterno)', hex: '#cccccc', priceAdd: 100 },
];

// Extra services
export const extraServices = [
  { id: 'installazione', name: 'Installazione', description: 'Posa in opera professionale', pricePerUnit: 80 },
  { id: 'trasporto', name: 'Trasporto', description: 'Consegna al piano', pricePerUnit: 50 },
  { id: 'rimozione', name: 'Rimozione Vecchi Infissi', description: 'Smaltimento incluso', pricePerUnit: 40 },
  { id: 'motorizzazione', name: 'Motorizzazione', description: 'Motore elettrico', pricePerUnit: 150 },
  { id: 'sensore_vento', name: 'Sensore Vento/Pioggia', description: 'Per tapparelle/tende', pricePerUnit: 80 },
  { id: 'telecomando', name: 'Telecomando', description: 'Controllo remoto', pricePerUnit: 30 },
  { id: 'cassonetto', name: 'Cassonetto Esterno', description: 'Per tapparella', pricePerUnit: 120 },
  { id: 'controtelaio', name: 'Controtelaio', description: 'Monoblocco', pricePerUnit: 60 },
];

// Starting dimensions (mm) for a new quote line, so the user rarely starts from a blank 1000×1000
const DEFAULT_SIZES = {
  finestre: [1200, 1400],
  portafinestre: [1400, 2200],
  porte: [1000, 2100],
  scorrevoli_patio: [2000, 2200],
  scorrevoli: [2000, 2200],
  pieghevoli: [3000, 2200],
  portoni: [2500, 2200],
  tapparelle: [1200, 1500],
  persiane: [1200, 1400],
  cassonetti: [1200, 300],
  monoblocchi: [1200, 1500],
  controtelai: [1200, 1400],
  zanzariere: [1200, 1400],
  frangisole: [1200, 1400],
  tende: [3000, 2500],
};
const DEFAULT_SIZE_OVERRIDES = {
  finestra_1_anta: [700, 1300],
  finestra_1_anta_sopraluce: [700, 1600],
  finestra_1_anta_sottoluce: [700, 1600],
  finestra_2_ante_sopraluce: [1200, 1700],
  finestra_3_ante: [1800, 1400],
  finestra_fissa: [800, 800],
  finestra_oblo: [600, 600],
  portafinestra_1_anta: [800, 2200],
  portafinestra_1_anta_sopraluce: [800, 2600],
  portafinestra_2_ante_sopraluce: [1400, 2600],
  portafinestra_3_ante: [2100, 2200],
  portafinestra_3_ante_sopraluce: [2100, 2600],
  portafinestra_4_ante: [2800, 2200],
  portafinestra_4_ante_sopraluce: [2800, 2600],
  porta_ingresso_fisso_sx: [1400, 2100],
  porta_ingresso_fisso_dx: [1400, 2100],
  porta_ingresso_semifisso_sx: [1400, 2100],
  porta_ingresso_semifisso_dx: [1400, 2100],
  porta_ingresso_laterale: [1400, 2100],
  scorrevole_3_ante: [3000, 2200],
  scorrevole_4_ante: [4000, 2200],
  patio_3_ante: [3000, 2200],
  patio_4_ante: [4000, 2200],
  pieghevole_2_ante: [1600, 2200],
  pieghevole_3_ante: [2400, 2200],
  pieghevole_6_ante: [4800, 2200],
};

// €/m² used when the tenant price list has no entry for a product/profile:
// catalog default × profile multiplier (same values the Settings page pre-fills).
export function catalogPricePerSqm(subcategoryId, profileId = 'pvc') {
  let defaultPrice = 250;
  productCategories.forEach(c => c.subcategories.forEach(s => {
    if (s.id === subcategoryId) defaultPrice = s.defaultPrice;
  }));
  const profile = profileTypes.find(p => p.id === profileId) || profileTypes[0];
  return Math.round(defaultPrice * profile.defaultMultiplier);
}

export function defaultSize(categoryId, subcategoryId) {
  const [width, height] = DEFAULT_SIZE_OVERRIDES[subcategoryId] || DEFAULT_SIZES[categoryId] || [1000, 1000];
  return { width, height };
}

// Helper functions
export function getProductType(categoryId, subcategoryId) {
  const category = productCategories.find(c => c.id === categoryId);
  if (!category) return null;
  const subcategory = category.subcategories.find(s => s.id === subcategoryId);
  return subcategory ? { category, subcategory } : null;
}

export function getAllProductTypes() {
  const types = [];
  productCategories.forEach(category => {
    category.subcategories.forEach(subcategory => {
      types.push({
        categoryId: category.id,
        categoryName: category.name,
        subcategoryId: subcategory.id,
        subcategoryName: subcategory.name,
        icon: subcategory.icon,
        defaultPrice: subcategory.defaultPrice,
        hasThresholdOption: category.hasThresholdOption || false
      });
    });
  });
  return types;
}

export function calculateProductPrice(config) {
  const { 
    basePrice, // base price per m² for this product type
    profilePrice, // specific price per m² for this profile (if set)
    width, // in mm
    height, // in mm
    glassType,
    openingType,
    glazingBead,
    threshold,
    color,
    doorPanel,
    quantity = 1
  } = config;

  // Calculate area in m²
  const areaM2 = (width / 1000) * (height / 1000);
  
  // Use profile-specific price if available, otherwise use base price
  const pricePerSqm = profilePrice || basePrice || 250;
  
  // Base price
  let unitPrice = pricePerSqm * areaM2;
  
  // Add glass type extra
  const glass = glassTypes.find(g => g.id === glassType);
  if (glass) unitPrice += glass.priceAdd;
  
  // Add opening type extra
  const opening = openingTypes.find(o => o.id === openingType);
  if (opening) unitPrice += opening.priceAdd;
  
  // Add glazing bead extra
  const bead = glazingBeadTypes.find(b => b.id === glazingBead);
  if (bead) unitPrice += bead.priceAdd;
  
  // Add threshold extra (for French doors)
  const thresh = thresholdOptions.find(t => t.id === threshold);
  if (thresh) unitPrice += thresh.priceAdd;
  
  // Add color extra
  const col = defaultColors.find(c => c.id === color);
  if (col) unitPrice += col.priceAdd;

  // Add entry door panel extra
  const panel = doorPanels.find(p => p.id === doorPanel);
  if (panel) unitPrice += panel.priceAdd;
  
  return {
    unitPrice: Math.round(unitPrice * 100) / 100,
    totalPrice: Math.round(unitPrice * quantity * 100) / 100,
    areaM2: Math.round(areaM2 * 100) / 100
  };
}

export default productCategories;
